module.exports = __webpack_public_path__ + "img/norway-logo-icon.26dabdb8.png";